import axios from 'axios';

// const ACESSO = 'http://localhost:3000/' //Local
const ACESSO = 'https://api.prodrigues.com.br/' //Produção

const api = axios.create({
  baseURL: ACESSO
})

export default api;